"use client";

import React, { useEffect, useState } from "react";
import axios from "axios";
import Post from "../../Post";
import Spacing from "../../Spacing";
import { API_URL } from "../../../Config/environment";

const LIMIT = 6;

export default function BlogSectionStyle2() {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPreviousPage, setHasPreviousPage] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchBlogs = async (page) => {
    try {
      setLoading(true);

      const resp = await axios.get(
        `${API_URL}/blog/home-page?page=${page}&limit=${LIMIT}`
      );

      const blogData = resp?.data?.data;

      setBlogs(blogData?.blogs || []);
      setCurrentPage(blogData?.currentPage || 1);
      setLastPage(blogData?.lastPage || 1);
      setHasNextPage(blogData?.hasNextPage || false);
      setHasPreviousPage(blogData?.hasPreviousPage || false);
    } catch (error) {
      console.error("Blog fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs(1);
  }, []);

  const handlePageChange = (page) => {
    if (page < 1 || page > lastPage) return;
    fetchBlogs(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="container">

      <div className="row cs_row_gap_50">
        {loading ? (
          <div className="col-12 text-center py-5">
            <div className="spinner-border text-dark" />
          </div>
        ) : (
          blogs?.map((item, index) => (
            <div className="col-xl-4 col-md-6" key={item.id || index}>
              <Post {...item} />
            </div>
          ))
        )}
      </div>

      <Spacing md="110" lg="70" />

      {/* Modern Pagination */}
      <div className="pagination-wrapper">
        <button
          className="pagination-btn"
          disabled={!hasPreviousPage}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          ← Previous
        </button>

        <div className="pagination-info">
          Page {currentPage} of {lastPage}
        </div>

        <button
          className="pagination-btn"
          disabled={!hasNextPage}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next →
        </button>
      </div>

      {/* Internal Styles */}
      <style jsx>{`
  .pagination-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    margin-top: 40px;
  }

  .pagination-btn {
    padding: 10px 24px;
    border-radius: 30px;
    border: 1px solid #2563eb;
    background: #eff6ff;
    color: #1e40af;
    font-weight: 600;
    transition: all 0.3s ease;
    min-width: 140px;
  }

  .pagination-btn:hover:not(:disabled) {
    background-color: #2563eb;
    color: #fff;
    box-shadow: 0 6px 18px rgba(37, 99, 235, 0.3);
    transform: translateY(-3px);
  }

  .pagination-btn:disabled {
    background: #f3f4f6;
    border-color: #e5e7eb;
    color: #9ca3af;
    cursor: not-allowed;
  }

  .pagination-info {
    font-size: 17px;
    font-weight: 600;
    color: #1f2937;
  }
`}</style>


    </div>
  );
}
